import {BaseComponentLifecycleEventHandler} from "../../infrastructure/handlers/base-component-lifecycle-event-handler";
import {COMPONENT_STATES} from "../consts";
import {ComponentController} from "../../infrastructure/controllers/component-controller";

export class EmptyLoadingStateHandler extends BaseComponentLifecycleEventHandler {

  onInitialized(controller: ComponentController) {
    controller.store.setDomainModel({});

    super.onInitialized(controller);
  }

  onLoaded() {
    super.onLoaded();

    this.controller.store.setComponentState(COMPONENT_STATES.loaded);
  }
}
